<template>
    <v-button rounded :outline="outline" :flat="flat" :small="small" :dense="dense" :round="round" :disable="disable"
              :no-caps="noCaps" :size="size" :color="color"
              :label="label | capitalize"
              type="submit"
              :loading="getNested('busy', form) || busy"
              :icon="icon"
              :icon-right="iconRight"
              class="no-shadow"
              @click="$emit('click', $event)">
        <span slot="loading">
            <q-spinner-puff class="on-left" color="white"></q-spinner-puff> {{ loadingLabel | capitalize }}
        </span>
    </v-button>
</template>

<script>
    import { QSpinnerPuff } from 'quasar-framework'
    import VButton from './VButton'
    import helpers from '../../helpers/methods'

    let { getNested } = helpers

    let mixins = [{
        props: VButton.props,
        methods: {
            getNested
        }
    }]

    export default {
        name: 'VSubmit',

        mixins,

        props: {
            form: {
                type: Object,
                default: null
            },
            busy: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                required: true
            },
            loadingLabel: String
        },

        components: {
            QSpinnerPuff
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VSubmit.vue